export default __webpack_public_path__ + "static/media/bulb.0ff78144.svg";